import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { EnrollProvider } from "@/context/EnrollContext";
import { EnrollDialog } from "@/components/EnrollDialog";
import Home from "@/pages/Home";
import NiviLanding from "@/pages/NiviLanding";

function App() {
  return (
    <div className="App">
      <EnrollProvider>
        <BrowserRouter>
          <Routes>
            {/* Original home page - restored */}
            <Route path="/" element={<Home />} />
            {/* Nivi chat landing - opens on CTA click */}
            <Route path="/chat" element={<NiviLanding />} />
          </Routes>
          {/* Must be inside BrowserRouter to use useNavigate */}
          <EnrollDialog />
        </BrowserRouter>
        <Toaster position="top-center" richColors />
      </EnrollProvider>
    </div>
  );
}

export default App;
